/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminDocumentTemplateControllerCreateDocument } from '../fn/document-template/admin-document-template-controller-create-document';
import { AdminDocumentTemplateControllerCreateDocument$Params } from '../fn/document-template/admin-document-template-controller-create-document';
import { adminDocumentTemplateControllerDeleteDocument } from '../fn/document-template/admin-document-template-controller-delete-document';
import { AdminDocumentTemplateControllerDeleteDocument$Params } from '../fn/document-template/admin-document-template-controller-delete-document';
import { adminDocumentTemplateControllerGetDocumentById } from '../fn/document-template/admin-document-template-controller-get-document-by-id';
import { AdminDocumentTemplateControllerGetDocumentById$Params } from '../fn/document-template/admin-document-template-controller-get-document-by-id';
import { adminDocumentTemplateControllerSearchOffset } from '../fn/document-template/admin-document-template-controller-search-offset';
import { AdminDocumentTemplateControllerSearchOffset$Params } from '../fn/document-template/admin-document-template-controller-search-offset';
import { adminDocumentTemplateControllerUpdateDocument } from '../fn/document-template/admin-document-template-controller-update-document';
import { AdminDocumentTemplateControllerUpdateDocument$Params } from '../fn/document-template/admin-document-template-controller-update-document';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { documentTemplateControllerCreateDocument } from '../fn/document-template/document-template-controller-create-document';
import { DocumentTemplateControllerCreateDocument$Params } from '../fn/document-template/document-template-controller-create-document';
import { documentTemplateControllerDeleteDocument } from '../fn/document-template/document-template-controller-delete-document';
import { DocumentTemplateControllerDeleteDocument$Params } from '../fn/document-template/document-template-controller-delete-document';
import { documentTemplateControllerGetDocumentById } from '../fn/document-template/document-template-controller-get-document-by-id';
import { DocumentTemplateControllerGetDocumentById$Params } from '../fn/document-template/document-template-controller-get-document-by-id';
import { documentTemplateControllerSearchCursor } from '../fn/document-template/document-template-controller-search-cursor';
import { DocumentTemplateControllerSearchCursor$Params } from '../fn/document-template/document-template-controller-search-cursor';
import { documentTemplateControllerSearchOffset } from '../fn/document-template/document-template-controller-search-offset';
import { DocumentTemplateControllerSearchOffset$Params } from '../fn/document-template/document-template-controller-search-offset';
import { documentTemplateControllerUpdateDocument } from '../fn/document-template/document-template-controller-update-document';
import { DocumentTemplateControllerUpdateDocument$Params } from '../fn/document-template/document-template-controller-update-document';
import { DocumentTemplateDto } from '../models/document-template-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class DocumentTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentTemplateControllerSearchCursor()` */
  static readonly DocumentTemplateControllerSearchCursorPath = '/api/document-template/cursor';

  /**
   * 커서 기반 치료 문서 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerSearchCursor$Response(params: DocumentTemplateControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return documentTemplateControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 커서 기반 치료 문서 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerSearchCursor(params: DocumentTemplateControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.documentTemplateControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateControllerSearchOffset()` */
  static readonly DocumentTemplateControllerSearchOffsetPath = '/api/document-template/offset';

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerSearchOffset$Response(params: DocumentTemplateControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return documentTemplateControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerSearchOffset(params: DocumentTemplateControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.documentTemplateControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateControllerGetDocumentById()` */
  static readonly DocumentTemplateControllerGetDocumentByIdPath = '/api/document-template/{id}';

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerGetDocumentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerGetDocumentById$Response(params: DocumentTemplateControllerGetDocumentById$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return documentTemplateControllerGetDocumentById(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerGetDocumentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerGetDocumentById(params: DocumentTemplateControllerGetDocumentById$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.documentTemplateControllerGetDocumentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateControllerDeleteDocument()` */
  static readonly DocumentTemplateControllerDeleteDocumentPath = '/api/document-template/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerDeleteDocument$Response(params: DocumentTemplateControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return documentTemplateControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateControllerDeleteDocument(params: DocumentTemplateControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.documentTemplateControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateControllerUpdateDocument()` */
  static readonly DocumentTemplateControllerUpdateDocumentPath = '/api/document-template/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateControllerUpdateDocument$Response(params: DocumentTemplateControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return documentTemplateControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateControllerUpdateDocument(params: DocumentTemplateControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.documentTemplateControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateControllerCreateDocument()` */
  static readonly DocumentTemplateControllerCreateDocumentPath = '/api/document-template';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateControllerCreateDocument$Response(params: DocumentTemplateControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return documentTemplateControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateControllerCreateDocument(params: DocumentTemplateControllerCreateDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.documentTemplateControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateControllerSearchOffset()` */
  static readonly AdminDocumentTemplateControllerSearchOffsetPath = '/api/document-template-admin/offset';

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerSearchOffset$Response(params: AdminDocumentTemplateControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminDocumentTemplateControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 페이지 기반 치료 문서 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerSearchOffset(params: AdminDocumentTemplateControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminDocumentTemplateControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateControllerGetDocumentById()` */
  static readonly AdminDocumentTemplateControllerGetDocumentByIdPath = '/api/document-template-admin/{id}';

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateControllerGetDocumentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerGetDocumentById$Response(params: AdminDocumentTemplateControllerGetDocumentById$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return adminDocumentTemplateControllerGetDocumentById(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateControllerGetDocumentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerGetDocumentById(params: AdminDocumentTemplateControllerGetDocumentById$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.adminDocumentTemplateControllerGetDocumentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateControllerDeleteDocument()` */
  static readonly AdminDocumentTemplateControllerDeleteDocumentPath = '/api/document-template-admin/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerDeleteDocument$Response(params: AdminDocumentTemplateControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return adminDocumentTemplateControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateControllerDeleteDocument(params: AdminDocumentTemplateControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.adminDocumentTemplateControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateControllerUpdateDocument()` */
  static readonly AdminDocumentTemplateControllerUpdateDocumentPath = '/api/document-template-admin/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateControllerUpdateDocument$Response(params: AdminDocumentTemplateControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return adminDocumentTemplateControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateControllerUpdateDocument(params: AdminDocumentTemplateControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.adminDocumentTemplateControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateControllerCreateDocument()` */
  static readonly AdminDocumentTemplateControllerCreateDocumentPath = '/api/document-template-admin';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateControllerCreateDocument$Response(params: AdminDocumentTemplateControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
    return adminDocumentTemplateControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateControllerCreateDocument(params: AdminDocumentTemplateControllerCreateDocument$Params, context?: HttpContext): Observable<DocumentTemplateDto> {
    return this.adminDocumentTemplateControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateDto>): DocumentTemplateDto => r.body)
    );
  }

}
